import Cookies from 'js-cookie';
import 'lazysizes';

document.addEventListener('DOMContentLoaded', () => {
  /*
  ----------------
  CREDITS
  ----------------
  */

  console.log('%c \nDevelopment by Cold Rice \n \ncold-rice.info \n \n', 'color: grey');

  /*
  ----------------
  VARS
  ----------------
  */

  let isLargeQuery = window.matchMedia('(min-width: 1024px)').matches;
  const featuredContentEls = Array.from(document.querySelectorAll('.home-featured-content'));
  const mainSearch = document.querySelector('#predictive-search-container');
  const productGridEls = Array.from(document.querySelectorAll('.product-grid-carousel'));
  const collectionFilterEls = Array.from(document.querySelectorAll('.collection-filters'));
  const isMainProduct = document.querySelector('.main-product');
  const modalOpenerEls = Array.from(document.querySelectorAll('.modal-opener'));
  const modalEls = Array.from(document.querySelectorAll('.def-modal'));
  const dropdownEls = Array.from(document.querySelectorAll('.def-dropdown'));
  const recommendationEls = Array.from(document.querySelectorAll('.product-recommendations'));
  const mainNav = document.querySelector('.main-header');
  const cartSection = document.querySelector('.main-cart-section');
  const copyLinks = Array.from(document.querySelectorAll('.copy-link'));
  const cookieBarEl = document.getElementById('cookie-bar');
  const optionSelectorEls = Array.from(document.querySelectorAll('.options-selector'));
  const largeInlineCarouselEls = Array.from(document.querySelectorAll('.large-inline-carousel'));
  const shapesCarouselEls = Array.from(document.querySelectorAll('.shapes-carousel'));
  const masonryGridEls = Array.from(document.querySelectorAll('.masonry-grid'));
  const backToTopEls = Array.from(document.querySelectorAll('.back-to-top'));

  /*
  ----------------
  COOKIE BAR
  ----------------
  */

  // set initial cookie state
  if (Cookies.get('june-cookie-consent') === 'accept') {
    document.body.classList.add('cookies-accepted');
  }

  // initialize cookie bar if applicable
  if (cookieBarEl) {
    import('./classes/CookieBar.js').then(({ default: CookieBar }) => {
      new CookieBar({
        el: cookieBarEl,
      });
    });
  }

  /*
  ----------------
  FACEBOOK TRACK PAGE VIEW
  ----------------
  */

  if (document.body.classList.contains('cookies-accepted')) {
    fbq('init', '408190634089291');
    fbq('track', 'PageView');
  }

  /*
  ----------------
  FEATURED CONTENT
  ----------------
  */

  if (featuredContentEls.length) {
    import('./classes/FeaturedContent.js').then(({ default: FeaturedContent }) => {
      featuredContentEls.forEach((el) => {
        new FeaturedContent({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  MAIN PRODUCT
  ----------------
  */

  if (isMainProduct) {
    import('./classes/VariantPicker.js').then(({ default: VariantPicker }) => {
      window.customElements.define('variant-picker', VariantPicker);
    });

    import('./classes/Product.js').then(({ default: Product }) => {
      new Product({
        el: isMainProduct,
        isLargeQuery,
      });
    });
  }

  /*
  ----------------
  CART
  ----------------
  */

  if (cartSection) {
    import('./classes/Cart.js').then(({ default: Cart }) => {
      window.customElements.define('cart-section', Cart);
    });

    import('./classes/AddOnProduct.js').then(({ default: AddOnProduct }) => {
      window.customElements.define('add-on-product', AddOnProduct);
    });
  }

  /*
  ----------------
  MAIN NAV
  ----------------
  */

  if (mainNav) {
    import('./classes/MainNav.js').then(({ default: MainNav }) => {
      new MainNav({
        el: mainNav,
      });
    });
  }

  /*
  ----------------
  SEARCH
  ----------------
  */

  if (mainSearch) {
    import('./classes/Search.js').then(({ default: Search }) => {
      new Search({
        el: mainSearch,
      });
    });
  }

  /*
  ----------------
  PRODUCT GRID
  ----------------
  */

  if (productGridEls.length) {
    import('./classes/ProductGrid.js').then(({ default: ProductGrid }) => {
      productGridEls.forEach((el) => {
        new ProductGrid({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  PRODUCT ITEM
  ----------------
  */

  import('./classes/ProductItem.js').then(({ default: ProductItem }) => {
    window.customElements.define('product-item', ProductItem);
  });

  /*
  ----------------
  COLLECTION FILTER
  ----------------
  */

  if (collectionFilterEls.length) {
    import('./classes/CollectionFilter.js').then(({ default: CollectionFilter }) => {
      collectionFilterEls.forEach((el) => {
        new CollectionFilter({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  MODAL
  ----------------
  */

  if (modalEls.length) {
    import('./classes/Modal.js').then(({ default: Modal }) => {
      modalEls.forEach((el) => {
        new Modal({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  MODAL OPENER
  ----------------
  */

  if (modalOpenerEls.length) {
    import('./classes/ModalOpener.js').then(({ default: ModalOpener }) => {
      modalOpenerEls.forEach((el) => {
        new ModalOpener({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  DROPDOWN
  ----------------
  */

  if (dropdownEls.length) {
    import('./classes/Dropdown.js').then(({ default: Dropdown }) => {
      dropdownEls.forEach((el) => {
        new Dropdown({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  RECOMMENDATIONs
  ----------------
  */

  if (recommendationEls.length) {
    import('./classes/ProductRecommendations.js').then(({ default: ProductRecommendations }) => {
      recommendationEls.forEach((el) => {
        new ProductRecommendations({
          el: el,
          isLargeQuery,
        });
      });
    });
  }

  /*
  ----------------
  COPY LINK
  ----------------
  */

  if (copyLinks.length) {
    import('./classes/CopyLink.js').then(({ default: CopyLink }) => {
      copyLinks.forEach((el) => {
        new CopyLink({
          el: el,
        });
      });
    });
  }

  /*
  ----------------
  MASONRY GRID
  ----------------
  */

  if (masonryGridEls.length) {
    import('./classes/MasonryGrid.js').then(({ default: MasonryGrid }) => {
      masonryGridEls.forEach((el) => {
        new MasonryGrid({
          el: el,
        });
      });
    });
  }

  /*
  ----------------
  OPTIONS SELECTOR
  ----------------
  */

  if (optionSelectorEls.length) {
    import('./classes/OptionsSelector.js').then(({ default: OptionsSelector }) => {
      optionSelectorEls.forEach((el) => {
        new OptionsSelector({
          el: el,
        });
      });
    });
  }

  /*
  ----------------
  LARGE INLINE CAROUSEL
  ----------------
  */

  if (largeInlineCarouselEls.length) {
    import('./classes/LargeInlineCarousel.js').then(({ default: LargeInlineCarousel }) => {
      largeInlineCarouselEls.forEach((el) => {
        new LargeInlineCarousel({
          el: el,
        });
      });
    });
  }

  /*
  ----------------
  SHAPES CAROUSEL
  ----------------
  */

  if (shapesCarouselEls.length) {
    import('./classes/ShapesCarousel.js').then(({ default: ShapesCarousel }) => {
      shapesCarouselEls.forEach((el) => {
        new ShapesCarousel({
          el: el,
        });
      });
    });
  }

  /*
  ----------------
  BACK TO TOP
  ----------------
  */

  if (backToTopEls.length) {
    import('./classes/BackToTop.js').then(({ default: BackToTop }) => {
      backToTopEls.forEach((el) => {
        new BackToTop({
          el: el,
        });
      });
    });
  }

  /*
  ----------------
  RESIZE
  ----------------
  */

  let resizeTimer = null;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      let newIsLargeQuery = window.matchMedia('(min-width: 992px)').matches;

      if (newIsLargeQuery !== isLargeQuery) {
        window.location.reload();
      }

      isLargeQuery = newIsLargeQuery;
    }, 450);
  });
});
